import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  TableSortLabel,
  TablePagination,
  Switch,
  FormControlLabel,
  Toolbar,
  Typography,
  Tooltip,
  IconButton,
  withStyles,
  makeStyles,
} from "@material-ui/core";
import { lighten } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import PropTypes from "prop-types";
import AADService from "../funcionesAuth.js";
import CheckRole from "../CheckRole";
import { DecryptData } from "../DatosEncriptados/EncryptedFunctions";

const headCellsRiesgos = [
  {
    id: "idEvaluacion",
    numeric: false,
    disablePadding: false,
    label: "Id Evaluación",
  },
  { id: "idActivo", numeric: false, disablePadding: true, label: "Id Activo" },
  {
    id: "activoevaluado",
    numeric: false,
    disablePadding: false,
    label: "Activo Evaluado",
  },
  { id: "idRiesgo", numeric: false, disablePadding: true, label: "Id Riesgo" },
  { id: "evento", numeric: false, disablePadding: false, label: "Evento" },
  {
    id: "descripcionriesgo",
    numeric: false,
    disablePadding: false,
    label: "Descripcion Riesgo",
  },
];

const headCellsVulnT = [
  {
    id: "idimplementador",
    numeric: false,
    disablePadding: true,
    label: "ID Implementador",
  },
  {
    id: "nombre",
    numeric: false,
    disablePadding: false,
    label: "Nombre",
  },
  {
    id: "descripcion",
    numeric: false,
    disablePadding: false,
    label: "Descripción",
  },
];

const headCellsVulnNT = [
  {
    id: "idlineasbase",
    numeric: false,
    disablePadding: true,
    label: "ID LineasBase",
  },
  {
    id: "nombre",
    numeric: false,
    disablePadding: false,
    label: "Nombre",
  },
];

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#2c2a29",
    color: "white",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: "#f4f4f4",
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHeadRiesgos(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
        >
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </TableCell>
        {headCellsRiesgos.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className="label"
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHeadRiesgos.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableHeadVulnT(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
        >
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </TableCell>
        {headCellsVulnT.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className="label"
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHeadVulnT.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableHeadVulnNT(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
        >
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </TableCell>
        {headCellsVulnNT.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className="label"
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHeadVulnNT.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {},
  highlight:
    theme.palette.mode === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;
  return (
    <Toolbar>
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Evaluaciones
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete" size="large">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton aria-label="filter list" size="large">
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStylesModal = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  container: {
    maxHeight: "40vh",
    minHeight: "40vh",
  },
}));

const stylesSelect = {
  control: (base) => ({
    ...base,
    fontFamily: "Roboto",
  }),
  menu: (base) => ({
    ...base,
    fontFamily: "CIBFont Sans Regular",
  }),
  option: (provided, state) => ({
    ...provided,
  }),
};

const NewNuevoPlanesAccion = (props) => {
  const classes = useStyles();
  // Assuming CheckRole is available
  const check = new CheckRole("/NewNuevoPlanAccion");
  const [opcionesGenerales, setOpcionesGenerales] = React.useState([]);
  const [companiaDat, setCompaniaDat] = React.useState([]);
  const [usuariosDat, setUsuariosDat] = React.useState([]);
  const [usuariosDatNeg, setUsuariosDatNeg] = React.useState([]);
  const [riesgos, setRiesgos] = React.useState([]);
  const [acis, setAcis] = React.useState([]);
  const [lbs, setLbs] = React.useState([]);
  const [riesgosTodo, setRiesgosTodo] = React.useState([]);
  const [acisTodo, setAcisTodo] = React.useState([]);
  const [lbsTodo, setLbsTodo] = React.useState([]);

  const [tipoComp2, setTipoComp2] = React.useState([]);
  const [estadoPOST, setEstadoPost] = React.useState(0);
  let history = useHistory();
  const [validated, setValidated] = useState(false);
  const [esCiber, setEsCiber] = useState(false);
  const [esTI, setEsTI] = useState(false);
  
  const [responsablePA, setresponsablePA] = useState(null);
  const [riesgosSelected, setRiesgosSelected] = React.useState([]);
  const [acisSelected, setAcisSelected] = React.useState([]);
  const [lbsSelected, setLbsSelected] = React.useState([]);

  const [modalShowRiesgos, setModalShowRiesgos] = React.useState(false);
  const [modalShowAcis, setModalShowAcis] = React.useState(false);
  const [modalShowLbs, setModalShowLbs] = React.useState(false);
  const [planAccionData, setPlanAccionData] = useState(null);
  const [direccion, setDireccion] = React.useState(false);
  const [datContenidos, setDatContenidos] = React.useState([]);
  const [analistaSeleccionado, setAnalistaSeleccionado] = useState(null);
  const [controlesData, setControlesData] = useState([]);
  const [seccionActiva, setSeccionActiva] = useState(null);
  const [analistaRiesgos, setAnalistaRiesgos] = React.useState(null);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  useEffect(() => {
    const fetchUsuario = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "usuarios/menu/" +
          localStorage.getItem("usuario") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const encryptedUser = await result.json();
      const decryptedUser = DecryptData(encryptedUser);
      let usuario = JSON.parse(decryptedUser);
      let opciones = [];
      let permisos = [];
      for (let i = 0; i < usuario.length; i++) {
        permisos = usuario[i].permisos.split(";");
        opciones.push({ opcion: usuario[i].url_opcion, permisos: permisos });
      }
      setOpcionesGenerales(opciones);
    };
    const obtenerCompañias = async () => {
      try {
        const result = await fetch(
          process.env.REACT_APP_API_URL + "general/compania/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        let datCompania = await result.json();
        setCompaniaDat(datCompania);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    const obtenerAnalistas = async () => {
      const resultAnalistas = await fetch(
        process.env.REACT_APP_API_URL + "usuariosroti/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datUsuariosAnalistas = await resultAnalistas.json();

      // Mapeo para el select
      let datAnalistaRiesgos = datUsuariosAnalistas.map(
        ({ idusuario: value, nombre: label }) => ({
          value,
          label,
        })
      );
      setUsuariosDatNeg(datAnalistaRiesgos);

      // Selección inicial si existe
      if (planAccionData && planAccionData.idanalistariesgos !== null) {
        let nombreAnalistaRiesgos = datUsuariosAnalistas
          .filter(
            (analista) => analista.idusuario == planAccionData.idanalistariesgos
          )
          .map(({ nombre }) => nombre)
          .pop();

        setAnalistaRiesgos({
          value: planAccionData.idanalistariesgos,
          label: nombreAnalistaRiesgos,
        });
      }
    };

    const obtenerUsuarios = async () => {
      try {
        const result1 = await fetch(
          process.env.REACT_APP_API_URL +
            "usuariosrolti/" +
            localStorage.getItem("idcompania") +
            "/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );

        let datUsuariosRO = await result1.json();
        setUsuariosDat(datUsuariosRO);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    const obtenerTipoComp = async () => {
      try {
        const result = await fetch(
          process.env.REACT_APP_API_URL + "general/tipoactivo/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        let data = await result.json();
        setTipoComp2(data);
      } catch (error) {
        console.error("Error fetching component types:", error);
      }
    };

    const obtenerRiesgos = async () => {
      try {
        const result = await fetch(
          process.env.REACT_APP_API_URL +
            "evaluacion/newListadoRiesgos/" +
            localStorage.getItem("idcompania") +
            "/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        let data = await result.json();
        if (result.status === 200) {
          setRiesgosTodo(data);
        } else {
          setRiesgosTodo([]);
        }
      } catch (error) {
        console.error("Error fetching risks:", error);
        setRiesgosTodo([]);
      }
    };
    const obtenerAcis = async () => {
      try {
        const result = await fetch(
          process.env.REACT_APP_API_URL +
            "evaluacion/newListadoActivos/" +
            localStorage.getItem("idcompania") +
            "/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        let data = await result.json();
        if (result.status === 200) {
          setAcisTodo(data);
        } else {
          setAcisTodo([]);
        }
      } catch (error) {
        console.error("Error fetching risks:", error);
        setAcisTodo([]);
      }
    };
    fetchUsuario();
    obtenerAnalistas();
    obtenerControles();
    obtenerTipoComp();
    obtenerUsuarios();
    obtenerCompañias();
    obtenerRiesgos();
    obtenerAcis();
    obtenerLineasBase();
    setSeccionActiva(determinarSeccionActiva());
  }, []);

  const determinarSeccionActiva = () => {
    if (riesgos.length > 0) return "riesgos";
    if (acis.length > 0) return "acis";
    return null;
  };
  const puedeAnadir = (tipoSeccion) => {
    const seccionActivaActual = determinarSeccionActiva();
    return seccionActivaActual === null || seccionActivaActual === tipoSeccion;
  };
  const manejarAnadirRiesgos = () => {
    if (puedeAnadir("riesgos")) {
      setModalShowRiesgos(true);
    } else if (puedeAnadir("acis")) {
      setModalShowAcis(true);
    } else {
      // Mostrar mensaje de error o alerta
      alert(
        "Solo se puede añadir a una sección a la vez. Ya hay elementos en otra sección."
      );
    }
  };
  const manejarAnadirAcis = () => {
    if (puedeAnadir("acis")) {
      setModalShowAcis(true);
    } else {
      // Mostrar mensaje de error o alerta
      alert(
        "Solo se puede añadir a una sección a la vez. Ya hay elementos en otra sección."
      );
    }
  };
  const manejarAnadirLbs = () => {
    if (puedeAnadir("lbs")) {
      setModalShowLbs(true);
    } else {
      alert(
        "Solo se puede añadir a una sección a la vez. Ya hay elementos en otra sección."
      );
    }
  };
  const obtenerControles = async () => {
    try {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "maestro/implementadores/0/" +
          localStorage.getItem("idcompania") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result.status >= 200 && result.status <= 300) {
        let data = await result.json();
        setControlesData(data);
      } else {
        setControlesData([]);
      }
    } catch (error) {
      console.error("Error fetching controles:", error);
      setControlesData([]);
    }
  };

  const obtenerLineasBase = async () => {
    try {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "evaluacion/newListadoLbs/" +
          localStorage.getItem("idcompania") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let data = await result.json();
      if (result.status === 200) {
      setLbsTodo(data);
      }
      else { 
        setLbsTodo([]);
      }
    } catch (error) {
      console.error("Error fetching lineas base:", error);
      setLbsTodo([]);
    }
  };

  const removeTag = (i) => {
    const newTags = [...datContenidos];
    newTags.splice(i, 1);
    setDatContenidos(newTags);
  };

  const inputKeyDown = (e) => {
    const val = e.target.value;
    if (e.key === "Enter" && val) {
      e.preventDefault();
      setValidated(false);
      if (
        datContenidos.find((tag) => tag.toLowerCase() === val.toLowerCase())
      ) {
        return;
      }
      setDatContenidos([...datContenidos, val]);
      let inputTag = document.getElementById("datosSeparados");
      inputTag.value = null;
    } else if (e.key === "Backspace" && !val) {
      removeTag(datContenidos.length - 1);
    }
  };

  function llenarTipoComp(data) {
    let tipo = [];
    for (const clave in data) {
      if (
        data[clave]["codigogeneral"] == "COM" ||
        data[clave]["codigogeneral"] == "NUB"
      ) {
        tipo.push(data[clave]);
      }
    }
    return tipo;
  }

  const tipoComp = llenarTipoComp(tipoComp2);
  const [state, setState] = useState("Activo");
  const [idState, setIdState] = useState(true);
  const [vRequired, setVRequired] = useState(true);
  const [ast, setAst] = useState("*");

  const changeRequired = () => {
    let tipoComp = parseInt(document.getElementById("componenteT").value);
    let compP = document.getElementById("ComponentePpal").checked;
    if (tipoComp == 11 || compP) {
      setVRequired(false);
      setAst("");
    } else {
      setVRequired(true);
      setAst("*");
    }
  };

  const handleChangeAnalista = (e) => {
    setAnalistaRiesgos({ value: e.value, label: e.label });
  };

  const MySelect = (props) => (
    <Select
      {...props}
      className="texto"
      options={props.options}
      placeholder={props.placeholder}
    />
  );

  const onChangeResponsablePA = (selectedOption) => {
    if (selectedOption) {
      setresponsablePA(selectedOption.idposicion);
    } else {
      setresponsablePA(null);
    }
  };

  const sendData = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else if (form.checkValidity() === true) {
      const timeElapsed = Date.now();
      const today = new Date(timeElapsed);
      let riesgosPATemp = [];

      riesgos.map((dat) => {
        riesgosPATemp.push({
          idnew_planaccionporriesgo: 0,
          idplanaccion: 0,
          idriesgo: dat.idriesgo,
          fechacreacion: today.toISOString(),
          idusuariocreacion: localStorage.getItem("idusuario"),
          fechamodificacion: today.toISOString(),
          idusuariomodificacion: localStorage.getItem("idusuario"),
          estadoasociacion: 1,
          disp_numerico1: 0.0,
          disp_numerico2: 0.0,
        });
      });
      let acisPATemp = [];
      acis.map((dat) => {
        acisPATemp.push({
          idplanaccionporaci: 0,
          idplanaccion: 0,
          idactivo: dat.idactivo,
          idactivoaplicacion: dat.idactivoaplicacion,
          fechacreacion: today.toISOString(),
          idusuariocreacion: localStorage.getItem("idusuario"),
          fechamodificacion: today.toISOString(),
          idusuariomodificacion: localStorage.getItem("idusuario"),
          estadoasociacion: 1,
          disp_numerico1: 0.0,
          disp_numerico2: 0.0,
        });
      });

      let lbsPATemp = [];
      lbs.map((dat) => {
        lbsPATemp.push({
          idplanaccionporlineabase: 0,
          idplanaccion: 0,
          idlinea_base: dat.idlineasbase,
          idactivo: dat.idactivo,
          idlineas_base_activos: dat.idlineas_base_activos,
          idcumplimiento_lineas_base_activo: dat.idcumplimiento_lineas_base_activo,
          fechacreacion: today.toISOString(),
          idusuariocreacion: localStorage.getItem("idusuario"),
          fechamodificacion: today.toISOString(),
          idusuariomodificacion: localStorage.getItem("idusuario"),
          estadoasociacion: 1,
          disp_numerico1: 0.0,
          disp_numerico2: 0.0,
        });
      });

      var data = JSON.stringify({
        idplanaccion: 0,
        nombre: document.getElementById("nombrePA").value,
        descripcion: document.getElementById("descripcionPA").value,
        fechainicio: document.getElementById("fechainicio").value,
        fechacompromisoinicial: document.getElementById(
          "fechacompromisoinicial"
        ).value,
        fechacompromisoactual: document.getElementById("fechacompromisoinicial")
          .value,
        fechafinalizacion: document.getElementById("fechacompromisoinicial")
          .value,
        estadopa: "Creado",
        porcentajeavance: 0.0,
        idposicionresponsablepa: parseInt(responsablePA),
        idanalistariesgos: analistaRiesgos ? analistaRiesgos.value : null,
        fechacreacion: today.toISOString(),
        idusuariocreacion: localStorage.getItem("idusuario"),
        fechamodificacion: today.toISOString(),
        idusuariomodificacion: localStorage.getItem("idusuario"),
        disp_numerico1: 1.0,
        disp_numerico2: 0.0,
        disp_varchar1: esCiber ? "Ciber" : null,
        disp_varchar2: esTI ? "TI" : null,
        Planaccionporriesgo: riesgosPATemp,
        Planaccionporactivos: acisPATemp,
        Planaccionporlineasbase: lbsPATemp,
      });

      let iniciofecha = document.getElementById("fechainicio").value;
      let finfecha = document.getElementById("fechacompromisoinicial").value;

      if (!esCiber && !esTI) {
        alert("Debe marcar al menos una clasificación: Ciber o TI.");
        return;
      }

      if (riesgosPATemp.length === 0 && acisPATemp.length === 0 && lbsPATemp.length === 0) {
        alert("Debe asociar un elemento al Plan de Acción antes de continuar.");
        return;
      }

      if (iniciofecha < finfecha) {
        fetch(
          process.env.REACT_APP_API_URL + "evaluacion/NewplandeAccion/0/",
          {
            method: "POST",
            body: data,
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: "Bearer " + token,
            },
          }
        )
          .then((data) =>
            data.json().then((response) => {
              if (data.status >= 200 && data.status < 300) {
                setEstadoPost(2);
                localStorage.setItem("idplanaccion", response.idplanaccion);
                history.push("/NewEditarPlanAccion");
              } else if (data.status >= 500) {
                setEstadoPost(5);
                if (
                  data.non_field_errors[0] ===
                  "The fields idplanaccion must make a unique set."
                ) {
                  setEstadoPost(6);
                }
              } else if (data.status >= 400 && data.status < 500) {
                setEstadoPost(4);
              }
            })
          )
          .catch(function (err) {});
      } else {
        let fecha_inicial = document.getElementById("fechainicio");
        let fecha_fin = document.getElementById("fechacompromisoinicial");
        fecha_fin.value = "";
        fecha_inicial.value = "";
        setEstadoPost(3);
      }
    }
    setValidated(true);
  };

  // Modal for Riesgos
  function MyVerticallyCenteredModalRiesgos(props) {
    const classes = useStylesModal();
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("idevaluacion");
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [queryText, setqueryText] = React.useState("");
    const [riesgosTemp, setRiesgosTemp] = React.useState(props.riesgos || []);

    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        setRiesgosTemp(
          riesgosTodo.map((n) => ({
            idevaluacion: n.idevaluacion,
            nombre: n.nombre,
            idriesgo: n.idriesgo,
          }))
        );
        return;
      }
      setRiesgosTemp([]);
    };

    const handleClick = (event, row) => {
      const selectedIndex = riesgosTemp.findIndex(
        (r) => r.idriesgo === row.idriesgo
      );
      let newSelected = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(riesgosTemp, row);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(riesgosTemp.slice(1));
      } else if (selectedIndex === riesgosTemp.length - 1) {
        newSelected = newSelected.concat(riesgosTemp.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          riesgosTemp.slice(0, selectedIndex),
          riesgosTemp.slice(selectedIndex + 1)
        );
      }
      setRiesgosTemp(newSelected);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    const handleChangeDense = (event) => {
      setDense(event.target.checked);
    };

    const isSelected = (idriesgo) =>
      riesgosTemp.some((r) => r.idriesgo === idriesgo);

    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Añadir Riesgos Asociados al Plan de Acción
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.root}>
            <Row>
              <Col sm={4} xs={2}>
                <Form className="buscar">
                  <Form.Control
                    type="text"
                    placeholder="Buscar por ID del Riesgo"
                    onChange={(e) => setqueryText(e.target.value)}
                    style={{ align: "center" }}
                  />
                </Form>
              </Col>
              <Col sm={4} xs={6}></Col>
              <Col sm={4} xs={6}>
                <Button
                  className="botonPositivo"
                  style={{ marginTop: "1%", width: "100%" }}
                  onClick={() => completarTabla(riesgosTemp, "riesgos")}
                >
                  Guardar
                </Button>
              </Col>
            </Row>
            <Paper className={classes.paper}>
              <TableContainer className={classes.container}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  aria-label="enhanced table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        padding="checkbox"
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        <Checkbox
                          indeterminate={
                            riesgosTemp.length > 0 &&
                            riesgosTemp.length < riesgosTodo.length
                          }
                          checked={
                            riesgosTodo.length > 0 &&
                            riesgosTemp.length === riesgosTodo.length
                          }
                          onChange={handleSelectAllClick}
                          inputProps={{ "aria-label": "select all riesgos" }}
                        />
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Id Evaluación
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Id Riesgo
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Característica de Seguridad
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Nivel de Riesgo
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stableSort(riesgosTodo, getComparator(order, orderBy))
                      .filter((row) =>
                        row.idriesgo.toString().includes(queryText)
                      )
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.idriesgo);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            onClick={(event) =>
                              handleClick(event, {
                                idevaluacion: row.idevaluacion,
                                idriesgo: row.idriesgo,
                                caracteristica_seguridad: row.caracteristica_seguridad,
                                nivelriesgo: row.nivelriesgo, 
                              })
                            }
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.idriesgo}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </TableCell>
                            <TableCell component="th" id={labelId} scope="row">
                              {row.idevaluacion}
                            </TableCell>
                            <TableCell align="left">{row.idriesgo}</TableCell>
                            <TableCell align="left">{row.caracteristica_seguridad}</TableCell>
                            <TableCell align="center">{row.nivelriesgo}</TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={riesgosTodo.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}              
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Filas por página:"
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Vista compacta"
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  function MyVerticallyCenteredModalAcis(props) {
    const classes = useStylesModal();
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("idactivo");
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [queryText, setqueryText] = React.useState("");
    const [acisTemp, setAcisTemp] = React.useState(props.acis || []);

    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        setAcisTemp(
          acisTodo.map((n) => ({
            idactivo: n.idactivo,
            nombre: n.activo,
            idactivoaplicacion: n.idcomponente,
            nombrecomponente: n.nombrecomponente,
            elemento_configuracion: n.elemento_configuracion,
          }))
        );
        return;
      }
      setAcisTemp([]);
    };

    const handleClick = (event, row) => {
      const selectedIndex = acisTemp.findIndex(
        (r) =>
          r.idactivo === row.idactivo && r.idactivoaplicacion === row.idactivoaplicacion
      );

      let newSelected = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(acisTemp, row);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(acisTemp.slice(1));
      } else if (selectedIndex === acisTemp.length - 1) {
        newSelected = newSelected.concat(acisTemp.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          acisTemp.slice(0, selectedIndex),
          acisTemp.slice(selectedIndex + 1)
        );
      }
      setAcisTemp(newSelected);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    const handleChangeDense = (event) => {
      setDense(event.target.checked);
    };

    const isSelected = (idactivo, idactivoaplicacion) =>
      acisTemp.some(
        (r) => r.idactivo === idactivo && r.idactivoaplicacion === idactivoaplicacion
      );

    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Añadir Activos de Información y Aplicaciones Asociados al Plan de
            Acción
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.root}>
            <Row>
              <Col sm={4} xs={2}>
                <Form className="buscar">
                  <Form.Control
                    type="text"
                    placeholder="Buscar por ID del ACI"
                    onChange={(e) => setqueryText(e.target.value)}
                    style={{ align: "center" }}
                  />
                </Form>
              </Col>
              <Col sm={4} xs={6}></Col>
              <Col sm={4} xs={6}>
                <Button
                  className="botonPositivo"
                  style={{ marginTop: "1%", width: "100%" }}
                  onClick={() => completarTabla(acisTemp, "acis")}
                >
                  Guardar
                </Button>
              </Col>
            </Row>
            <Paper className={classes.paper}>
              <TableContainer className={classes.container}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  aria-label="enhanced table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        padding="checkbox"
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        <Checkbox
                          indeterminate={
                            acisTemp.length > 0 &&
                            acisTemp.length < acisTodo.length
                          }
                          checked={
                            acisTodo.length > 0 &&
                            acisTemp.length === acisTodo.length
                          }
                          onChange={handleSelectAllClick}
                          inputProps={{ "aria-label": "select all acis" }}
                        />
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Idactivo ACI
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Nombre ACI
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Idactivo Aplicación
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Nombre Aplicación
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Codigo de Aplicación
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stableSort(acisTodo, getComparator(order, orderBy))
                      .filter((row) =>
                        row.idactivo.toString().includes(queryText)
                      )
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.idactivo, row.idcomponente)
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            onClick={(event) =>
                              handleClick(event, {
                                idactivo: row.idactivo,
                                activo: row.activo,
                                idactivoaplicacion: row.idcomponente,
                                nombrecomponente: row.nombrecomponente,
                                elemento_configuracion:
                                  row.elemento_configuracion,
                              })
                            }
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={`${row.idactivo}-${row.idactivoaplicacion}`}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </TableCell>
                            <TableCell component="th" id={labelId} scope="row">
                              {row.idactivo}
                            </TableCell>
                            <TableCell align="left">{row.activo}</TableCell>
                            <TableCell align="center">
                              {row.idcomponente}
                            </TableCell>
                            <TableCell align="left">
                              {row.nombrecomponente}
                            </TableCell>
                            <TableCell align="left">
                              {row.elemento_configuracion}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={acisTodo.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}              
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Filas por página:"
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Vista compacta"
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  function MyVerticallyCenteredModalLbs(props) {
    const classes = useStylesModal();
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("idactivo");
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [queryText, setqueryText] = React.useState("");
    const [lbsTemp, setLbsTemp] = React.useState(props.lbs || []);

    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        setLbsTemp(
          lbsTodo.map((n) => ({
            idcumplimiento_lineas_base_activo: n.idcumplimiento_lineas_base_activo,
            idlineas_base_activos: n.idlineas_base_activos,
            idlinea_base: n.idlinea_base,
            nombrelb: n.nombrelb,
            nombrecis: n.nombrecis,
            tipo_lb: n.tipo_lb,
            idactivo: n.idactivo,
            nombreaplicacion: n.nombreaplicacion,
            elemento_configuracion: n.elemento_configuracion,
          }))
        );
        return;
      }
      setLbsTemp([]);
    };

    const handleClick = (event, row) => {
      const selectedIndex = lbsTemp.findIndex(
        (r) =>
          r.idlinea_base === row.idlinea_base && r.idactivo === row.idactivo
      );

      let newSelected = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(lbsTemp, row);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(lbsTemp.slice(1));
      } else if (selectedIndex === lbsTemp.length - 1) {
        newSelected = newSelected.concat(lbsTemp.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          lbsTemp.slice(0, selectedIndex),
          lbsTemp.slice(selectedIndex + 1)
        );
      }
      setLbsTemp(newSelected);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    const handleChangeDense = (event) => {
      setDense(event.target.checked);
    };

    const isSelected = (idlinea_base, idactivo) =>
      lbsTemp.some(
        (r) => r.idlinea_base === idlinea_base && r.idactivo === idactivo
      );

    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Añadir líneas base Asociadas al Plan de Acción
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.root}>
            <Row>
              <Col sm={4} xs={2}>
                <Form className="buscar">
                  <Form.Control
                    type="text"
                    placeholder="Buscar por ID de la línea base"
                    onChange={(e) => setqueryText(e.target.value)}
                    style={{ align: "center" }}
                  />
                </Form>
              </Col>
              <Col sm={4} xs={6}></Col>
              <Col sm={4} xs={6}>
                <Button
                  className="botonPositivo"
                  style={{ marginTop: "1%", width: "100%" }}
                  onClick={() => completarTabla(lbsTemp, "lbs")}
                >
                  Guardar
                </Button>
              </Col>
            </Row>
            <Paper className={classes.paper}>
              <TableContainer className={classes.container}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  aria-label="enhanced table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        padding="checkbox"
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        <Checkbox
                          indeterminate={
                            lbsTemp.length > 0 &&
                            lbsTemp.length < lbs.length
                          }
                          checked={
                            lbsTodo.length > 0 &&
                            lbsTemp.length === lbsTodo.length
                          }
                          onChange={handleSelectAllClick}
                          inputProps={{ "aria-label": "select all lbs" }}
                        />
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Id Línea Base
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Nombre Línea Base
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        NombreCIS
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Tipo de Línea Base
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Id Activo
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Nombre Aplicación
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        Código de Aplicación
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stableSort(lbsTodo, getComparator(order, orderBy))
                      .filter((row) =>
                        row.idlinea_base.toString().includes(queryText)
                      )
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.idlinea_base, row.idactivo)
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            onClick={(event) =>
                              handleClick(event, {
                                idcumplimiento_lineas_base_activo: row.idcumplimiento_lineas_base_activo,
                                idlineas_base_activos: row.idlineas_base_activos,
                                idlinea_base: row.idlinea_base,
                                nombrelb: row.nombrelb,
                                nombrecis: row.nombrecis,
                                tipo_lb: row.tipo_lb,
                                idactivo: row.idactivo,
                                nombreaplicacion: row.nombreaplicacion,
                                elemento_configuracion: row.elemento_configuracion,
                              })
                            }
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={`${row.idlinea_base}-${row.idactivo}`}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </TableCell>
                            <TableCell component="th" id={labelId} scope="row">
                              {row.idlinea_base}
                            </TableCell>
                            <TableCell align="left">{row.nombrelb}</TableCell>
                            <TableCell align="center">
                              {row.nombrecis}
                            </TableCell>
                            <TableCell align="left">
                              {row.tipo_lb}
                            </TableCell>
                            <TableCell align="left">
                              {row.idactivo}
                            </TableCell>
                            <TableCell align="left">
                              {row.nombreaplicacion}
                            </TableCell>
                            <TableCell align="left">
                              {row.elemento_configuracion}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={lbsTodo.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}              
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Filas por página:"
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Vista compacta"
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  const completarTabla = (obj, id) => {
    let temp = [];

    switch (id) {
      case "riesgos":
        setRiesgosSelected(obj);
        setRiesgos(obj.filter((item) => item !== undefined));
        setModalShowRiesgos(false);
        break;
      case "acis":
        setAcisSelected(obj);
        setAcis(obj.filter((item) => item !== undefined));
        setModalShowAcis(false);
        break;
      case "lbs":
        setLbsSelected(obj);
        setLbs(obj.filter((item) => item !== undefined));
        setModalShowLbs(false);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <MyVerticallyCenteredModalRiesgos
        riesgos={riesgosSelected}
        show={modalShowRiesgos}
        onHide={() => setModalShowRiesgos(false)}
      />
      <MyVerticallyCenteredModalAcis
        acis={acisSelected}
        show={modalShowAcis}
        onHide={() => setModalShowAcis(false)}
      />
      <MyVerticallyCenteredModalLbs
        lbs={lbsSelected}
        show={modalShowLbs}
        onHide={() => setModalShowLbs(false)}
      />

      <Row>
        <Col>
          <h2 className="subtitulo">Nuevo Plan de Acción</h2>
        </Col>
      </Row>
      <hr />
      <Form
        id="formData"
        onSubmit={(e) => sendData(e)}
        noValidate
        validated={validated}
      >
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Id Plan de Acción</label>
          </Col>
          <Col sm={8} xs={12}>
            <input
              type="text"
              disabled
              className="form-control text-center font-weight-bold"
              placeholder="ID Automático"
              id="idplanaccion"
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Nombre Plan de Acción*</label>
          </Col>
          <Col sm={8} xs={12}>
            <input
              type="text"
              className="form-control text-center"
              placeholder="Nombre del Plan de Acción"
              required
              id="nombrePA"
            />
            <Form.Control.Feedback type="invalid">
              Por favor introduzca un nombre.
            </Form.Control.Feedback>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Descripción*</label>
          </Col>
          <Col sm={8} xs={10}>
            <input
              type="text"
              className="form-control text-center"
              placeholder="Descripción del Plan de Acción"
              required
              rows="4"
              id="descripcionPA"
            />
            <Form.Control.Feedback type="invalid">
              Por favor introduzca una Descripción.
            </Form.Control.Feedback>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">
              Responsable del Plan de Acción*
            </label>
          </Col>
          <Col sm={3} xs={10}>
            <Select
              placeholder={"Seleccione el responsable..."}
              getOptionLabel={(option) => option.nombre}
              getOptionValue={(option) => option.idposicion}
              options={usuariosDat}
              onChange={onChangeResponsablePA}
              styles={stylesSelect}
            />
            <Form.Control.Feedback type="invalid">
              Por favor seleccione un responsable.
            </Form.Control.Feedback>
          </Col>
          <Col sm={2} xs={12}>
            <label className="label form-label">Responsable*</label>
          </Col>
          <Col sm={3} xs={10}>
            <MySelect
              className="texto"
              onChange={handleChangeAnalista}
              options={usuariosDatNeg}
              value={analistaRiesgos}
            />
            <Form.Control.Feedback type="invalid">
              Por favor seleccione un responsable.
            </Form.Control.Feedback>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Estado</label>
          </Col>
          <Col sm={3} xs={12}>
            <input
              type="text"
              disabled
              className="form-control text-center"
              placeholder="Creado"
              id="estadoPA"
            />
          </Col>
          <Col sm={2} xs={12}>
            <label className="label form-label">Porcentaje Avance</label>
          </Col>
          <Col sm={3} xs={12}>
            <input
              type="text"
              disabled
              className="form-control text-center"
              placeholder="0%"
              id="procentajePA"
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Fecha Inicio*</label>
          </Col>
          <Col sm={3} xs={12}>
            <input
              type="date"
              className="form-control text-center"
              id="fechainicio"
              required={vRequired}
              min={new Date().toISOString().split("T")[0]}
            />
            <Form.Control.Feedback type="invalid">
              Por favor introduzca la Fecha de inicio.
            </Form.Control.Feedback>
          </Col>
          <Col sm={2} xs={12}>
            <label className="label form-label">Compromiso Inicial*</label>
          </Col>
          <Col sm={3} xs={12}>
            <input
              type="date"
              className="form-control text-center"
              id="fechacompromisoinicial"
              required={vRequired}
              min={
                new Date(Date.now() + 24 * 60 * 60 * 1000)
                  .toISOString()
                  .split("T")[0]
              }
            />
            <Form.Control.Feedback type="invalid">
              Por favor introduzca la Fecha de Compromiso inicial.
            </Form.Control.Feedback>
          </Col>
        </Row>
                        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Clasificación*</label>
          </Col>
          <Col sm={8} xs={12}>
            <div style={{ display: "flex", alignItems: "center", marginTop: "6px", gap: "32px" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  id="esCiber"
                  checked={esCiber}
                  onChange={(e) => setEsCiber(e.target.checked)}
                  style={{ width: "20px", height: "20px", marginRight: "10px", cursor: "pointer" }}
                />
                <label htmlFor="esCiber" className="label form-label" style={{ marginBottom: 0, cursor: "pointer" }}>
                  Ciber
                </label>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  id="esTI"
                  checked={esTI}
                  onChange={(e) => setEsTI(e.target.checked)}
                  style={{ width: "20px", height: "20px", marginRight: "10px", cursor: "pointer" }}
                />
                <label htmlFor="esTI" className="label form-label" style={{ marginBottom: 0, cursor: "pointer" }}>
                  TI
                </label>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={4} xs={1}></Col>
          <Col sm={3} xs={3}>
            {check.checkPermits(opcionesGenerales, "POST") ? (
              <Button type="submit" className="botonPositivo" id="send">
                Guardar
              </Button>
            ) : (
              ""
            )}
          </Col>
          <Col sm={3} xs={3}>
            <Link to="NewPlanAccion">
              <Button className="botonNegativo">Descartar</Button>
            </Link>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <br />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={10}>
            <h3 className="subtitulo">Riesgos asociados al Plan de Acción</h3>
          </Col>
          <Col md={2}>
            <Button
              className="botonIngreso"
              onClick={manejarAnadirRiesgos}
              disabled={!puedeAnadir("riesgos")}
              variant={puedeAnadir("riesgos") ? "primary" : "secondary"}
            >
              Añadir
            </Button>
          </Col>
        </Row>

        {/* Tabla de riesgos */}
        <Row className="mb-3">
          <TableContainer component={Paper} className="table table-bordered">
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Id Evaluación</StyledTableCell>
                  <StyledTableCell align="left">Id Riesgo</StyledTableCell>
                  <StyledTableCell align="left">Característica</StyledTableCell>
                  <StyledTableCell align="left">Nivel de riesgo</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {riesgos.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell>{row.idevaluacion}</StyledTableCell>
                    <StyledTableCell align="left">{row.idriesgo}</StyledTableCell>
                    <StyledTableCell align="left">{row.caracteristica_seguridad}</StyledTableCell>
                    <StyledTableCell align="left">{row.nivelriesgo}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Row>
        <Row className="mb-3">
          <Col md={10}>
            <h3 className="subtitulo">
              Activos de Información asociados al Plan de Acción
            </h3>
          </Col>
          <Col md={2}>
            <Button
              className="botonIngreso"
              onClick={manejarAnadirAcis}
              disabled={!puedeAnadir("acis")}
              variant={puedeAnadir("acis") ? "primary" : "secondary"}
            >
              Añadir
            </Button>
          </Col>
        </Row>

        {/* Tabla de acis */}
        <Row className="mb-3">
          <TableContainer component={Paper} className="table table-bordered">
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Idactivo ACI</StyledTableCell>
                  <StyledTableCell align="left">Nombre ACI</StyledTableCell>
                  <StyledTableCell align="left">Idactivo Aplicación</StyledTableCell>
                  <StyledTableCell align="left">Nombre Aplicación</StyledTableCell>
                  <StyledTableCell align="left">Codigo de Aplicación</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {acis.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell>{row.idactivo}</StyledTableCell>
                    <StyledTableCell align="left">{row.activo}</StyledTableCell>
                    <StyledTableCell align="left">{row.idactivoaplicacion}</StyledTableCell>
                    <StyledTableCell align="left">{row.nombrecomponente}</StyledTableCell>
                    <StyledTableCell align="left">{row.elemento_configuracion}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Row>
        <Row className="mb-3">
          <Col md={10}>
            <h3 className="subtitulo">
              Líneas base asociadas al Plan de Acción
            </h3>
          </Col>
          <Col md={2}>
            <Button
              className="botonIngreso"
              onClick={manejarAnadirLbs}
              disabled={!puedeAnadir("lbs")}
              variant={puedeAnadir("lbs") ? "primary" : "secondary"}
            >
              Añadir
            </Button>
          </Col>
        </Row>
        {/* Tabla de líneasbase */}
        <Row className="mb-3">
          <TableContainer component={Paper} className="table table-bordered">
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Id Línea Base</StyledTableCell>
                  <StyledTableCell align="left">Nombre Línea Base</StyledTableCell>
                  <StyledTableCell align="left">NombreCIS</StyledTableCell>
                  <StyledTableCell align="left">Tipo Línea Base</StyledTableCell>
                  <StyledTableCell align="left">Id Activo</StyledTableCell>
                  <StyledTableCell align="left">Nombre Aplicación</StyledTableCell>
                  <StyledTableCell align="left">Código de Aplicación</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {lbs.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell>{row.idlinea_base}</StyledTableCell>
                    <StyledTableCell align="left">{row.nombrelb}</StyledTableCell>
                    <StyledTableCell align="left">{row.nombrecis}</StyledTableCell>
                    <StyledTableCell align="left">{row.tipo_lb}</StyledTableCell>
                    <StyledTableCell align="left">{row.idactivo}</StyledTableCell>
                    <StyledTableCell align="left">{row.nombreaplicacion}</StyledTableCell>
                    <StyledTableCell align="left">{row.elemento_configuracion}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Row>
      </Form>
    </>
  );
};

export default NewNuevoPlanesAccion;
